import * as moment from 'moment'

export interface Week {
    number: number
    monday: Date
}

/**
 * Calculates how many weeks are left from the start date. Will default to now.
 * @param start The start date
 */
export function weeksLeft(start?: Date): Week[] {
    let startDate = moment(start || new Date())
    if(startDate.day() !== 1)
        startDate = startDate.day(-1)

    let weeksLeft = moment(startDate).add(1, 'year').date(0)
        .diff(startDate, 'week')

    let dates: Week[] = []
    for(let week = 0; week <= weeksLeft; week++) {
        let current = moment(startDate).add(week, 'week').toDate()
        dates.push({
            number: weekNumber(current),
            monday: current
        })
    }

    return dates
}

/**
 * Creates a week number from a date e.g. 29-01-2018 outputs 5.
 * @param date The date to get the week name for.
 */
export function weekNumber(date: Date | string): number {
    return moment(date).week()
}

/**
 * Creates a date on monday for the requested weeknumber in a year. Will default to now.
 * @param week The week number to get the date for.
 * @param year The year to get the date for.
 */
export function mondayOfWeek(week?: number, year?: number): Date {
    week = week || moment().week()
    year = year || moment().year()

    return moment().year(year).week(week).day(1).toDate()
}

export function getNewTtl(minutes: number = 10): Date {
  return new Date(new Date().getTime() + minutes * 60000)
}
